import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface MailProgressEvent {
  type: 'START' | 'COMPLETE';
  upsiIds?: number[];
  formValue?: any;
}


@Injectable({ providedIn: 'root' })
export class MailProgressService {

private source = new BehaviorSubject<MailProgressEvent | null>(null);
progress$ = this.source.asObservable();

 start(upsiIds: number[], formValue: any) {
  const user = sessionStorage.getItem('access_user');

  if (!user) {
    console.warn('No logged-in user found for UPSI progress');
    return;
  }

  const key = `ACTIVE_UPSI_IDS_${user}`;
  localStorage.setItem(key, JSON.stringify(upsiIds));

   this.source.next({ type: 'START', upsiIds, formValue });
}



  stop() {
    this.source.next(null);
  }

complete() {
  this.source.next({ type: 'COMPLETE' });
}

   getActiveUpsiKey(): string | null {
    const accessUser = sessionStorage.getItem('access_user');
    return accessUser ? `ACTIVE_UPSI_IDS_${accessUser}` : null;
  }

}
